import { render } from "./RelSelection.vue?vue&type=template&id=3a565fdb&scoped=true&ts=true"
import script from "./RelSelection.vue?vue&type=script&lang=ts"
export * from "./RelSelection.vue?vue&type=script&lang=ts"

import "./RelSelection.vue?vue&type=style&index=0&id=3a565fdb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a565fdb"]])

export default __exports__